import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import ChosenClients from "./ChosenClients.js";
import API from "../../actions";

export default props => {
    const [open, setOpen] = useState(false);
    const [left, setLeft] = useState([]);
    const [right, setRight] = useState([]);
    const [problems, setProblems] = useState([]);

    const handleClickOpen = async () => {
        const l = await API.getClientsFromTherapistNewsletter();
        setLeft(l);
        setOpen(true);
        setTags(l);
    };

    const handleClose = () => {
        setOpen(false);
        setRight([]);
        setLeft([]);
    };

    const setTags = l => {
        let allTagsMap = {};
        l.map(c => JSON.parse(c.tags) || [])
            .flat()
            .forEach(t => {
                if (t) allTagsMap[t] = true;
            });
        const allTags = [];
        Object.keys(allTagsMap).forEach(key => {
            allTags.push(key);
        });
        setProblems(allTags);
    };

    const handleSend = () => {
        API.newsletterCustom(
            props.name,
            props.description,
            right.map(client => client.id)
        );
        setOpen(false);
    };

    return (
        <>
            <Button variant="contained" color="primary" onClick={handleClickOpen}>
                Send til udvalg
            </Button>
            {open ? (
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">Hvem skal der sendes til?</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Vælg klienter du ønsker at sende "{props.name}" til.
                            <ChosenClients lhs={left} rhs={right} tags={problems} onChange={setRight} />
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} color="primary">
                            Annuler
                        </Button>

                        <Button onClick={handleSend} color="primary" autoFocus>
                            Send
                        </Button>
                    </DialogActions>
                </Dialog>
            ) : (
                ""
            )}
        </>
    );
};
